import { render } from "./CompetentionLogo2020.vue?vue&type=template&id=6791d460"
import script from "./CompetentionLogo2020.vue?vue&type=script&lang=js"
export * from "./CompetentionLogo2020.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__